import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { sessionService } from 'redux-react-session';

export const getManagerSessions = createAsyncThunk(
  'sessions/getManagerSessions', 
  async ({ manager_id, limit = 10, offset = 0, orders = { created_at: 'desc' } }, { rejectWithValue }) => {
    const attributes = ['id', 'active_at', 'created_at'];
    const params = { limit, offset, orders, attributes };

    try {
      const response = await axios.get(`/managers/${manager_id}/sessions`, { params });

      return response.data;
    } catch (error) {
      return rejectWithValue({
        type: error.response?.data?.error?.type ?? null,
        message: error.response?.data?.error?.message ?? 'Something went wrong',
        status: error.response?.status
      });
    }
  }
);
export const getSession = createAsyncThunk(
  'sessions/getSession', 
  async (id, { rejectWithValue }) => {
    const attributes = ['id', 'access_token'];
    const params = { attributes };

    try {
      const response = await axios.get(`/sessions/${id}`, { params });

      return response.data;
    } catch (error) {
      return rejectWithValue({
        type: error.response?.data?.error?.type ?? null,
        message: error.response?.data?.error?.message ?? 'Something went wrong',
        status: error.response?.status
      });
    }
  }
);
export const createSession = createAsyncThunk(
  'sessions/createSession',
  async ({ email, password, confirmation_code, attributes }, { rejectWithValue }) => {
    try {
      const data = { email, password, confirmation_code, attributes };
      const response = await axios.post('/sessions', data);
      
      axios.defaults.params = { ...axios.defaults.params, access_token: response.data.session.access_token };
      axios.defaults.data = { ...axios.defaults.data, access_token: response.data.session.access_token };

      await sessionService.saveSession({ accessToken: response.data.session.access_token });
      
      return response.data;
    } catch (error) {
      return rejectWithValue({
        type: error.response?.data?.error?.type ?? null,
        message: error.response?.data?.error?.message ?? 'Something went wrong',
        status: error.response?.status
      });
    }
  }
);
export const deleteActiveSession = createAsyncThunk(
  'sessions/deleteActiveSession',
  async (controller, { rejectWithValue }) => {
    try {
      const response = await axios.delete('/sessions');
      try {
        await sessionService.deleteSession();
      
        if (controller) controller.abort();
        
        axios.defaults.signal = undefined;
        axios.defaults.params = undefined;
        axios.defaults.data = undefined;

        return response.status;
      } catch (error) {
          console.error(error);
          return rejectWithValue({
            type: error.response.data?.error?.type ?? null,
            message: error.response.data?.error?.message ?? 'Something went wrong',
            status: error.response.status
          });
      }
    } catch (error) {
        console.error(error);
        return rejectWithValue({
          type: error.response?.data?.error?.type ?? null,
          message: error.response?.data?.error?.message ?? 'Something went wrong',
          status: error.response?.status
        });
    }
  }
);
export const deleteSession = createAsyncThunk(
  'sessions/deleteSession', 
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/sessions/${id}`);

      return { status: response.status, id };
    } catch (error) {
      return rejectWithValue({
        type: error.response?.data?.error?.type ?? null,
        message: error.response?.data?.error?.message ?? 'Something went wrong',
        status: error.response?.status
      });
    }
  }
);
export const setLocalSession = createAction('sessions/setLocalSession');
export const clearLocalManagerSessions = createAction('sessions/clearLocalManagerSessions');